import React from "react";
import { Alert, Col } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import { useQuery } from "@apollo/client";
import { useTranslation } from "react-i18next";
import moment from "moment";
import { IconProp } from "@fortawesome/fontawesome-svg-core";

// graphql
import GET_INVOICES from "graphql/queries/GetInvoices";

// styling
import { Invoice } from "types";
import {
  CustomSection,
  SectionHeader,
  CustomRow,
  DownloadButton,
  DownloadButtonContainer,
} from "./MyBillingsStyling";

// types

const InvoiceList = () => {
  const { t } = useTranslation("my_billing");
  const { data, error, loading } = useQuery(GET_INVOICES, {
    fetchPolicy: "network-only",
  });

  if (loading) {
    return <Alert type="info" message={t("Loading invoices...")} />;
  }

  if (error) {
    return (
      <Alert
        type="error"
        message={t(
          "Error loading invoices. Please check your internet or let us know if this keeps happening."
        )}
      />
    );
  }

  return (
    <CustomSection style={{ marginTop: "48px" }}>
      <SectionHeader>{t("MY INVOICES")}</SectionHeader>
      {data.me.invoices.map((invoice: Invoice) => (
        <CustomRow key={invoice.id}>
          <Col xs={24} sm={24} md={12} lg={24} xl={11}>
            {invoice.id}
          </Col>
          <Col xs={12} sm={12} md={6} lg={12} xl={5}>
            {moment(new Date(invoice.billingDate)).format("LL")}
          </Col>
          <DownloadButtonContainer xs={12} sm={12} md={6} lg={12} xl={8}>
            <DownloadButton
              type="link"
              icon={<FontAwesomeIcon icon={faDownload as IconProp} />}
              href={invoice.url}
            >
              {t("DOWNLOAD PDF")}
            </DownloadButton>
          </DownloadButtonContainer>
        </CustomRow>
      ))}
    </CustomSection>
  );
};

export default InvoiceList;
